var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HelperService } from './helper.service';
import { of } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SigninService } from './signin/signin.service';
import { ToasterType, Toaster } from './shared/types';
import { ToasterService } from './toaster.service';
import { DataService } from './data.service';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "./signin/signin.service";
import * as i2 from "./toaster.service";
import * as i3 from "./data.service";
import * as i4 from "@angular/router";
var helper = new JwtHelperService();
var AuthService = /** @class */ (function () {
    function AuthService(signInService, _toastMessage, dataService, router) {
        this.signInService = signInService;
        this._toastMessage = _toastMessage;
        this.dataService = dataService;
        this.router = router;
        this.user = null;
        this._token = null;
        this.decodedToken = null;
        this.redirectUrl = null;
    }
    AuthService.prototype.setToken = function (token) {
        if (!token) {
            this._token = null;
            this.decodedToken = null;
            this.user = null;
            HelperService.setCookie({
                token: '',
                user: '',
            });
            return;
        }
        this._token = token;
        this.decodedToken = this.getDecodedToken();
        if (!this.user) {
            this.setUserInfo();
        }
    };
    Object.defineProperty(AuthService.prototype, "isUserLoggedIn", {
        get: function () {
            return this.token ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.setUserInfo = function () {
        var _this = this;
        if (!this.decodedToken) {
            return of();
        }
        return this.signInService.getUserInfo(this.decodedToken.email)
            .map(function (userDetails) {
            userDetails = userDetails && userDetails.data;
            _this.setUserDetails(userDetails);
            return userDetails;
        });
    };
    Object.defineProperty(AuthService.prototype, "token", {
        get: function () {
            return this._token;
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.onRouteTokenUpdate = function () {
        var _this = this;
        var onSuccessfullSignIn = function (roles) {
            var cookieRoles = [], accessRoles = ['refund_access', 'debit_access', 'distance_update_access', 'customer_deactivate_access', 'revoke_suspension', 'revoke_loyalty_suspension', 'revoke_penalty', 'revoke_blacklist', 'manager_profile_view', 'manager_search_role_edit', 'allow_p0_suspension', 'revoke_p0_suspension', 'remove_spd_fraud'];
            _this.signInService.setCookies({ roles: roles }).subscribe(function (res) {
                if (res['data'] && res['data'].data) {
                    for (var index in accessRoles) {
                        if (accessRoles[index] && res['data'].data.indexOf(accessRoles[index]) !== -1) {
                            cookieRoles.push(accessRoles[index]);
                        }
                    }
                }
                if (cookieRoles.length > 0) {
                    document.cookie = 'accessRoles=' + cookieRoles;
                }
                _this.dataService.updatePermissions(res['data']);
            });
        };
        this.signInService.getUserInfo().subscribe(function (result) {
            var response = result || {};
            response = response.data;
            _this.setUserDetails(response);
            if (response && response._id) {
                var roles = response.roles;
                document.cookie = 'Roles=' + roles;
                HelperService.setCookie({
                    name: response.email,
                    user: {
                        _id: response._id,
                        firstName: response.firstName,
                        emailId: response.email,
                    },
                });
                onSuccessfullSignIn(roles);
            }
            else {
                _this._toastMessage.showToaster(new Toaster({
                    type: ToasterType.WARNING,
                    message: 'User not found! Please contact support.',
                }));
            }
        }, function (err) {
            _this._toastMessage.showToaster(new Toaster({
                type: ToasterType.WARNING,
                message: err.error.message,
            }));
            _this.logOut();
        });
    };
    AuthService.prototype.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var routeToken, existingToken, token, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        routeToken = HelperService.routeParams().token || '';
                        existingToken = HelperService.accessCookie('token') || '';
                        routeToken = routeToken.split('?')[0];
                        existingToken = existingToken.split('?')[0];
                        token = routeToken || existingToken;
                        // if (routeToken) {
                        this.onRouteTokenUpdate();
                        // }
                        this.setTokenToCookie(token);
                        if (!token) {
                            return [2 /*return*/, false];
                        }
                        if (routeToken) {
                            url = HelperService.removeParam(['token']);
                            HelperService.redirect(url, false);
                        }
                        return [4 /*yield*/, this.initializeMaps(environment.googleMapsApiKey)];
                    case 1:
                        _a.sent();
                        this.setToken(token);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    AuthService.prototype.clearUserCred = function () {
        this.setToken(null);
    };
    AuthService.prototype.initializeMaps = function (apiKey) {
        return new Promise(function (resolve, _) {
            if (window['google']) {
                console.log("Google Maps script already loaded.");
                return resolve();
            }
            else {
                var script = document.createElement('script');
                script.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&libraries=geometry";
                script.onload = function () {
                    console.log("Google Maps script loaded successfully.");
                    resolve();
                };
                script.onerror = function () {
                    console.error("Failed to load Google Maps script.");
                    resolve();
                };
                document.body.appendChild(script);
            }
        });
    };
    AuthService.prototype.deleteAllCookies = function () {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf('=');
            var name_1 = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name_1 + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
    };
    AuthService.prototype.logOut = function () {
        this.signInService.logoutGoogle();
        this.clearUserCred();
        this.deleteAllCookies();
        setTimeout(function () {
            HelperService.redirect(environment.oauth);
        });
    };
    AuthService.prototype.getUserDetails = function () {
        if (this.user) {
            return of(this.user);
        }
        return this.setUserInfo();
    };
    AuthService.prototype.getDecodedToken = function () {
        if (!this.token) {
            return false;
        }
        var decodedToken = helper.decodeToken(this.token);
        return decodedToken;
    };
    AuthService.prototype.setUserDetails = function (user) {
        this.user = user;
    };
    AuthService.prototype.getToken = function () {
        return HelperService.accessCookie('token');
    };
    AuthService.prototype.clearToken = function () {
        this.setToken(null);
    };
    AuthService.prototype.setTokenToCookie = function (token) {
        HelperService.setCookie({
            token: token,
        });
        // document.cookie = `token=${token}`;
    };
    AuthService.ngInjectableDef = i0.defineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.inject(i1.SigninService), i0.inject(i2.ToasterService), i0.inject(i3.DataService), i0.inject(i4.Router)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
